import React from "react";
import "./edsider/dashboard.css";
import Avatar from "@mui/material/Avatar";
import TimeZoneHandler from "../../../handlers/TimeZoneHandler";

const TeacherAnnouncementCard = (props) => {

  function formatTimeDifference(dateString) {

    const currentDate = new Date()
    const providedDate = new Date(TimeZoneHandler.convertTimeByUserLocation(dateString));

    const timeDifferenceInMilliseconds = currentDate - providedDate
    const secondsDifference = Math.floor(timeDifferenceInMilliseconds / 1000)
    const minutesDifference = Math.floor(secondsDifference / 60)
    const hoursDifference = Math.floor(minutesDifference / 60)
    const daysDifference = Math.floor(hoursDifference / 24)
    const weeksDifference = Math.floor(daysDifference / 7)
    const monthsDifference = Math.floor(daysDifference / 30)
    const yearsDifference = Math.floor(daysDifference / 365)

    if (yearsDifference > 0) {
      return `${yearsDifference} ${
        yearsDifference === 1 ? "year" : "years"
      } ago`
    } else if (monthsDifference > 0) {
      return `${monthsDifference} ${
        monthsDifference === 1 ? "month" : "months"
      } ago`
    } else if (weeksDifference > 0) {
      return `${weeksDifference} ${
        weeksDifference === 1 ? "week" : "weeks"
      } ago`
    } else if (daysDifference > 0) {
      return `${daysDifference} ${daysDifference === 1 ? "day" : "days"} ago`
    } else if (hoursDifference > 0) {
      return `${hoursDifference} ${
        hoursDifference === 1 ? "hour" : "hours"
      } ago`
    } else if (minutesDifference > 0) {
      return `${minutesDifference} ${
        minutesDifference === 1 ? "minute" : "minutes"
      } ago`
    } else {
      return "Just now"
    }
  }

  return (
    <div className="row announcement-card">
      <div className="col-md-2 d-flex align-items-center">
        <Avatar
          sx={{ bgcolor: "#D9DEEF" }}
          alt={props.annonucements?.annoucement_title}
          src={props.annonucements?.annoucement_title}
        ></Avatar>
      </div>
      <div className="col-md-10 d-flex align-items-center">
        <div className="row d-flex">
          <div className="col-md-12 announcement-title pb-2">
            {props.annonucements?.annoucement_title}
          </div>
          <div className="col-md-12">
            <div className="row d-flex justify-content-between px-0">
              <div className="col-md-5 col-6 px-0 announcement-content ml-4">
                Posted by{" "}
                <b>
                  {props.annonucements?.create_user_table_id === "1" && "Admin"}
                  {props.annonucements?.create_user_table_id === "3" && "Parent"}
                  {props.annonucements?.create_user_table_id === "10" && "Teacher"}
                </b>
              </div>
              <div className="col-md-4 col-6 px-0 announcement-content d-flex justify-content-center">
                {formatTimeDifference(props.annonucements?.created_at)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TeacherAnnouncementCard
